<style lang="scss">
    @import '~@/assets/css/var';
    .small-font {
        &__row {
            line-height: 18px;
            margin-bottom: 15px;
            cursor: pointer;
            i {
                display: inline-block;
                color: #999;
                font-style: normal;
                border: 1px solid $border;
                width: 18px;
                text-align: center;
                border-radius: 5px;
                font-size: 12px;
                margin-right: 8px;
                &.red {
                    color: #fff;
                    background: #fd9927;
                    border-color: #fd9927;
                }
            }
            &:hover {
                color: $main;
            }
        }
    }
</style>
<template>

    <el-tabs v-model="activeName" type="border-card" class="small-font">

        <el-tab-pane label="热门咨询" name="first">
            <div class="small-font__row" v-for="(item, i) in list" :key="item.id" @click="updateOrReadRow(item)">
                <i :class="{red: i < 3}">{{i + 1}}</i> {{item.title}}
            </div>

        </el-tab-pane>

        <el-tab-pane label="一周速读" name="second">
            <div class="small-font__row" v-for="(item, i) in readList" :key="item.id" @click="updateOrReadRow(item)">
                <i :class="{red: i < 3}">{{i + 1}}</i> {{item.title}}
            </div>
        </el-tab-pane>
    </el-tabs>


</template>

<script>
    // import axios from '@/util/api'
    // import help from '@/util/help'
    export default {
        props: {
            api:{

                },

        },
        data() {
            return {
                list:[],
                readList:[],
                cols: [],
                query: {
                    headId : '',
                },
                activeName: "first",
                queryFunc: () => {},
            }
        },
        created() {
            this.loadData()
        },
        methods: {
            updateOrReadRow(row) {
                // 有修改权限就修改 没有就查看
                this.$emit('updateOrReadRow', row);
            },
            loadData() {

                this.$api.post(this.api.orderByCom)
                    .then(res => {
                        this.list = res;
                    })

                this.$api.post(this.api.orderByRead)
                    .then(res => {
                        this.readList = res;
                    })
            },
        }
    }
</script>
